import { Box, Stack } from '@mui/material';
import { type ReactNode } from 'react';

import { Panel } from './Panel.js';
import {
  PAGE_BACKGROUND_COLOR,
  STANDARD_LAYOUT_PADDING_X,
  STANDARD_LAYOUT_PADDING_Y,
} from '../../constants.js';
import { type PaddingVariant } from '../../types.js';

export interface PanelAndContentPageBodyProps {
  panelContent: ReactNode;
  children: ReactNode;
  isPanelContainerWidthFixed?: boolean;
  paddingVariants?: {
    panel?: PaddingVariant;
    content?: PaddingVariant;
  };
  panelPlacement?: 'Left' | 'Right';
}

export function PanelAndContentPageBody(props: PanelAndContentPageBodyProps) {
  const {
    panelContent,
    children,
    isPanelContainerWidthFixed = false,
    paddingVariants = {
      panel: 'Standard',
      content: 'Standard',
    },
    panelPlacement = 'Left',
  } = props;

  const panelComponent = (
    <Panel
      paddingVariant={paddingVariants.panel ?? 'Standard'}
      isPanelContainerWidthFixed={isPanelContainerWidthFixed}
    >
      {panelContent}
    </Panel>
  );

  return (
    <Stack flexDirection="row" flex={1} minHeight={0}>
      {panelPlacement === 'Left' && panelComponent}
      <Box
        flex={1}
        sx={{ overflowY: 'auto', backgroundColor: PAGE_BACKGROUND_COLOR }}
        {...(paddingVariants.content === 'None'
          ? { padding: 0 }
          : { paddingX: STANDARD_LAYOUT_PADDING_X, paddingY: STANDARD_LAYOUT_PADDING_Y })}
      >
        {children}
      </Box>
      {panelPlacement === 'Right' && panelComponent}
    </Stack>
  );
}
